module.exports = __webpack_public_path__ + "img/5.d1a59ac2.png";